import { apiDelete, apiGet, apiPost } from '../client';
import type { Vehicle, VehicleCreatePayload } from '@/types/api';

/** The backend forces owner_id to the caller; you cannot register on someone's behalf. */
export function listVehicles(): Promise<Vehicle[]> {
  return apiGet<Vehicle[]>('/vehicles');
}

export function createVehicle(payload: VehicleCreatePayload): Promise<Vehicle> {
  return apiPost<Vehicle>('/vehicles', { body: payload });
}

export function deleteVehicle(vehicleId: number): Promise<void> {
  return apiDelete<void>(`/vehicles/${vehicleId}`);
}
